import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageUtils } from '@/context/language-context';
import LanguageSelector from '@/components/language/LanguageSelector';

const Footer = () => {
  const { t } = useTranslation(['footer', 'common']);
  const { getUrlWithLanguage } = useLanguageUtils();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-purple-dark/90 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-2xl mb-4 bg-pink-gradient text-gradient">Pink Paradise</h3>
            <p className="text-gray-300 mb-6">
              The premier platform for authentic encounters and exclusive content.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-pink-light">{t('footer.platform')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><Link to={getUrlWithLanguage('/explore')} className="hover:text-pink-light transition-colors">{t('footer.explore')}</Link></li>
              <li><Link to={getUrlWithLanguage('/how-it-works')} className="hover:text-pink-light transition-colors">{t('footer.how_it_works')}</Link></li>
              <li><Link to={getUrlWithLanguage('/pricing')} className="hover:text-pink-light transition-colors">{t('footer.pricing')}</Link></li>
              <li><Link to={getUrlWithLanguage('/security')} className="hover:text-pink-light transition-colors">{t('footer.security')}</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-pink-light">{t('footer.resources')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><Link to={getUrlWithLanguage('/blog')} className="hover:text-pink-light transition-colors">{t('footer.blog')}</Link></li>
              <li><Link to={getUrlWithLanguage('/faq')} className="hover:text-pink-light transition-colors">{t('footer.faq')}</Link></li>
              <li><Link to={getUrlWithLanguage('/safety-tips')} className="hover:text-pink-light transition-colors">{t('footer.safety_tips')}</Link></li>
              <li><Link to={getUrlWithLanguage('/support')} className="hover:text-pink-light transition-colors">{t('footer.support')}</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-pink-light">{t('footer.legal')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><Link to={getUrlWithLanguage('/terms')} className="hover:text-pink-light transition-colors">{t('footer.terms')}</Link></li>
              <li><Link to={getUrlWithLanguage('/privacy')} className="hover:text-pink-light transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to={getUrlWithLanguage('/cookies')} className="hover:text-pink-light transition-colors">{t('footer.cookies')}</Link></li>
              <li><Link to={getUrlWithLanguage('/content-policy')} className="hover:text-pink-light transition-colors">{t('footer.content_policy')}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Pink Paradise. {t('footer.rights')}.
          </p>
          <div className="flex space-x-4">
            <LanguageSelector />
            <Link to={getUrlWithLanguage('/currency')} className="text-gray-400 hover:text-pink-light text-sm">
              {t('footer.currency')}: EUR
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
